import type { NewCopyAssignment } from '@typings/experiments';
import type { State } from 'types/redux';
import { selectAssignment } from '.';

const newCopySelector = (state: State) => {
	return (selectAssignment(state, ['newCopy']) ?? null) as NewCopyAssignment;
};

const isInNewCopyExperiment = (state: State) => {
	const newCopyAssignment = newCopySelector(state);
	return newCopyAssignment === 'new-copy';
};

export { newCopySelector, isInNewCopyExperiment };
